import { IProduct } from '@topshots/core-models';
import { Currency } from '../currency/currency';
import { Button } from 'shared-components';

export const ProductsTable = ({
  data,
  extraColumns,
  onClick,
  action,
}: {
  data: IProduct[];
  onClick?: (product: IProduct) => void;
  extraColumns?: ('confirmed' | 'archived' | 'public')[];
  action?: { title: string; handler: (product: IProduct) => void };
}) => {
  return (
    <table>
      <thead>
        <tr>
          <th>Name</th>
          <th>Price</th>
          {extraColumns?.includes('confirmed') && <th>Confirmed?</th>}
          {extraColumns?.includes('archived') && <th>Archived?</th>}
          {extraColumns?.includes('public') && <th>Public?</th>}
          {action && <th>&nbsp;</th>}
        </tr>
      </thead>
      <tbody>
        {data.map((p) => (
          <tr
            onClick={() => {
              onClick?.(p);
            }}
            key={p._id.toString()}
          >
            <td>{p.name}</td>
            <td>
              <Currency value={p.price} />
            </td>
            {extraColumns?.includes('confirmed') && (
              <td>{p.isConfirmed ? 'Yes' : 'No'}</td>
            )}
            {extraColumns?.includes('archived') && (
              <td>{p.isArchived ? 'Yes' : 'No'}</td>
            )}
            {extraColumns?.includes('public') && (
              <td>{p.isPublic ? 'Yes' : 'No'}</td>
            )}
            {action && (
              <td style={{ textAlign: 'right' }}>
                <Button
                  onClick={() => {
                    action.handler(p);
                  }}
                >
                  {action.title}
                </Button>
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
};
